import { DetailedHTMLProps, forwardRef, LabelHTMLAttributes, memo, ReactNode, useId } from "react";
import classNames from "classnames";
import { CheckboxBase, CheckboxBaseProps } from "../CheckboxBase";

import styles from "./styles.module.scss";

export type CheckboxSize = "sm" | "md";

export type CheckboxProps = Omit<CheckboxBaseProps, "checkboxBaseSize"> & {
  checkboxBaseClassName?: string,
  checkboxSize?: CheckboxSize,
  supportingText?: ReactNode,
  labelProps?: Omit<DetailedHTMLProps<LabelHTMLAttributes<HTMLLabelElement>, HTMLLabelElement>, "className">
  text: ReactNode,
}

export const Checkbox = memo(forwardRef<HTMLSpanElement, CheckboxProps>((
  {
    checkboxBaseClassName,
    checkboxSize = "md",
    text,
    supportingText,
    className,
    disabled,
    id,
    labelProps,
    ...props
  }, ref,
) => {
  const reactId = useId();
  const realId = id || reactId;

  return (
    <label
      {...labelProps}
      className={classNames(
        styles.root,
        className,
        styles[checkboxSize as keyof typeof styles],
        {
          [styles.hasSupportingText]: !!supportingText,
          [styles.disabled]: disabled,
        },
      )}
      htmlFor={realId}
    >
      <CheckboxBase
        ref={ref}
        checkboxBaseSize={checkboxSize}
        className={classNames(styles.checkboxBase, checkboxBaseClassName)}
        disabled={disabled}
        id={realId}
        {...props}
      />
      <span className={styles.text}>
        {text}
      </span>
      {
        !!supportingText &&
        <span className={styles.supportingText}>
          {supportingText}
        </span>
      }
    </label>
  );
}));